import { Trans, useT } from '@eturi/react-i18next'
import type { Feature } from '@op/services'
import cls from 'classnames'
import { memo } from 'react'
import { Link } from 'react-router-dom'
import { useIsScreenSize } from '../../hooks'
import { setPairModal } from '../../reducers/pair.slice'
import { useAppDispatch } from '../../types'
import { Btn, HybridModal } from '../../widgets'
import PairComparisonTable from '../Connect/PairComparisonTable'

type PairDeviceModalProps = {
	readonly feature?: Feature
	readonly onClose: () => void
	readonly showQuickPair?: boolean
}

const PairDeviceModal = ({ feature, showQuickPair = true, onClose }: PairDeviceModalProps) => {
	const d = useAppDispatch()
	const [t] = useT('pair_device')
	const isSm = useIsScreenSize('sm')

	return (
		<HybridModal size="md" header={t.$('actions.pair_device')} onClose={onClose}>
			<div className="flex flex-col items-center max-w-lg">
				{showQuickPair && (
					<p className="w-full mb-4 text-sm sm:text-base">
						<Trans i18nKey="pair_device.pair_compare_desc_1" />
					</p>
				)}

				<p className="w-full mb-6 text-sm sm:text-base">
					<Trans i18nKey="pair_device.pair_compare_desc_2" />
				</p>

				<PairComparisonTable feature={feature} />

				<HybridModal.Footer stacked>
					{showQuickPair && (
						<Btn
							className="w-full uppercase !mb-2 text-balance"
							size={isSm ? 'md' : 'sm'}
							onClick={() => {
								d(setPairModal({ feature, type: 'quick_pair' }))
							}}
						>
							{t('quick_pair_button')}
						</Btn>
					)}

					<Link
						className={cls(
							'btn',
							showQuickPair && 'btn-teal-invert border-solid border-2 border-teal',
							!showQuickPair && 'btn-teal',
							!isSm && 'btn-sm',
						)}
						to={{ pathname: '/connect', search: 'hideSkip=true' }}
						onClick={onClose}
					>
						{t.$('actions.full_pair')}
					</Link>

					<p className="text-balance text-center text-sm">
						*{t.$('connect.pair_modals.pairing_options_disclaimer')}
					</p>
				</HybridModal.Footer>
			</div>
		</HybridModal>
	)
}

export default /*@__PURE__*/ memo(PairDeviceModal)
